import Loadable from '../../components/loadable';

const MonthlyRunRatesGraphs = Loadable({
  loader: () => import('../../pages/revenue/monthly_run_rates_graphs'),
  type: 'block',
});

angular.module('gym').value('MonthlyRunRatesGraphs', MonthlyRunRatesGraphs);
